import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'react-i18next';

export type CertificateRequestForm = {
  phoneNumber: string;
  verificationCode: string;
  verificationId: string;
  verified: boolean;
  purpose: string;
};

const defaultValues: CertificateRequestForm = {
  phoneNumber: '',
  verificationCode: '',
  verificationId: '',
  verified: false,
  purpose: '',
};

const useCertificateRequestForm = () => {
  const { t } = useTranslation();

  const Schema = Yup.object().shape({
    phoneNumber: Yup.string()
      .required(t('휴대폰 번호를 입력해주세요.'))
      .matches(
        /^\d{3}-\d{3,4}-\d{4}$/,
        t('올바른 형식의 휴대폰 번호를 입력해주세요.'),
      ),
    verificationCode: Yup.string()
      .min(4, t('인증번호를 입력해주세요.'))
      .max(10, t('인증번호를 입력해주세요.'))
      .matches(/^[0-9]+$/, '숫자만 입력해주세요'),
    verificationId: Yup.string().required(''),
    verified: Yup.boolean().required(),
    purpose: Yup.string()
      .required(t('MYPAGE.사용 용도를 50자 이내로 입력해주세요.'))
      .max(50, t('MYPAGE.사용 용도를 50자 이내로 입력해주세요.')),
  });

  return useForm<CertificateRequestForm>({
    resolver: yupResolver(Schema),
    defaultValues,
    mode: 'onChange',
  });
};

export default useCertificateRequestForm;
